import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuthGuard } from './authentication/auth.guard';
import { AuthService, BBSFUtilitiesModule } from 'bbsf-utilities';



@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    BBSFUtilitiesModule
  ],
  providers: [
    AuthService,
    AuthGuard    

  ]
})
export class AuthModule { }
